import { all, call, put, select, takeLatest } from "redux-saga/effects";
import JsonPatch from "fast-json-patch";
import { ADD_NEW_PROPERTY,
  ADD_NEW_PROPERTY_SUCCESS,
  addNewPropertyFailure,
  addNewPropertyRequested,
  addNewPropertySuccess,
  FETCH_MY_PROPERTIES,
  fetchMyPropertiesFailure,
  fetchMyPropertiesRequested,
  fetchMyPropertiesSuccess,
  FETCH_SINGLE_PROPERTY,
  fetchSinglePropertyFailure,
  fetchSinglePropertyRequested,
  fetchSinglePropertySuccess,
  UPDATE_SINGLE_PROPERTY,
  UPDATE_SINGLE_PROPERTY_SUCCESS,
  updateSinglePropertyFailure,
  updateSinglePropertyRequested,
  updateSinglePropertySuccess } from "../actions/properties-action-types";
import httpClient from "./http-client";

export function* addNewPropertyHandler({ payload }) {
  yield put(addNewPropertyRequested());
  const user = yield select((state) => state?.user?.user);

  const request = {
    data: {
      ...payload,
      userId: user.identifier,
    },
    method: "POST",
    url: "/api/v1/properties",
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(addNewPropertyFailure(error));
  } else {
    yield put(addNewPropertySuccess(data.details.id));
  }
}

export function* fetchMyPropertiesHandler() {
  yield put(fetchMyPropertiesRequested());
  const user = yield select((state) => state?.user?.user);

  const request = {
    method: "GET",
    params: { userId: user.identifier },
    url: "/api/v1/properties/",
  };

  const {
    data, error,
  } = yield call(httpClient, request);

  if (error) {
    yield put(fetchMyPropertiesFailure(error));
  } else {
    yield put(fetchMyPropertiesSuccess(data.details));
  }
}

export function* fetchSinglePropertyHandler({ payload }) {
  yield put(fetchSinglePropertyRequested());

  const request = {
    method: "GET",
    url: `/api/v1/properties/${payload}`,
  };

  const {
    data, error,
  } = yield call(httpClient, request, true);

  if (error) {
    yield put(fetchSinglePropertyFailure(error));
  } else {
    yield put(fetchSinglePropertySuccess(data.details));
  }
}

export function* updateSinglePropertyHandler({ payload }) {
  yield put(updateSinglePropertyRequested());

  const result = JsonPatch.compare(payload.original, payload.updates);

  if (result.length) {
    const request = {
      data: { payload: result },
      method: "PATCH",
      url: `/api/v1/properties/${payload.original.identifier}`,
    };

    const { error } = yield call(httpClient, request, true);

    if (error) {
      yield put(updateSinglePropertyFailure(error));
    } else {
      yield put(updateSinglePropertySuccess(payload.original.identifier));
    }
  }
}

function* MyProperties() {
  yield all([
    takeLatest(ADD_NEW_PROPERTY, addNewPropertyHandler),
    takeLatest(FETCH_MY_PROPERTIES, fetchMyPropertiesHandler),
    takeLatest([FETCH_SINGLE_PROPERTY, ADD_NEW_PROPERTY_SUCCESS, UPDATE_SINGLE_PROPERTY_SUCCESS], fetchSinglePropertyHandler),
    takeLatest(UPDATE_SINGLE_PROPERTY, updateSinglePropertyHandler),
  ]);
}

export default MyProperties;
